export const CURRENT = 0;
export const ALL = 1;
export const BOTH = 2;
